export default __webpack_public_path__ + "static/media/poison.43956925.svg";